import { DialogClose } from '@/components/atoms/Dialog';
import { Button } from '@/components/atoms/NewPcButton';

import type { ReviewCommentTemplate } from '@/types/api';

import EmptyFaceIcon from '@/assets/icons/EmptyFaceIcon.svg?react';
import { ChevronRight } from 'lucide-react';
import {
  LayoutTemplateContainer,
  LayoutTemplateContent,
  LayoutTemplateController,
  LayoutTemplateTitle,
} from '../../_layouts/LayoutsEditTemplate';

export interface ListTemplateProps {
  templateList: ReviewCommentTemplate[];
  onAdd: () => void;
  onEdit: (tpl: ReviewCommentTemplate) => void;
}

export const ListTemplate: React.FC<ListTemplateProps> = ({ templateList, onAdd, onEdit }) => {
  return (
    <LayoutTemplateContainer>
      <LayoutTemplateTitle>
        <div className="">템플릿 편집</div>
      </LayoutTemplateTitle>
      <LayoutTemplateContent>
        {templateList.length === 0 ? (
          <EmptyList />
        ) : (
          templateList.map((tpl) => <TemplateItem tpl={tpl} onClick={() => onEdit(tpl)} />)
        )}
      </LayoutTemplateContent>
      <Controller onAdd={onAdd} />
    </LayoutTemplateContainer>
  );
};

export const EmptyList: React.FC = () => {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-[20px] text-gr-700 Body1S16">
      <EmptyFaceIcon />
      등록된 템플릿이 없습니다
    </div>
  );
};

export const TemplateItem = ({
  tpl,
  onClick,
}: {
  tpl: ReviewCommentTemplate;
  onClick: (tpl: ReviewCommentTemplate) => void;
}) => {
  return (
    <button
      key={tpl.TemplateNo}
      className=" flex h-[44px] w-full cursor-pointer items-center justify-between rounded-[8px] text-gr-700 transition-all Body2M16 hover:bg-gr-50"
      onClick={() => onClick(tpl)}
    >
      <span>{tpl.Title}</span>
      <ChevronRight className="h-6 w-6" />
    </button>
  );
};

export const Controller = ({ onAdd }: { onAdd: () => void }) => {
  return (
    <LayoutTemplateController>
      <DialogClose asChild>
        <Button variant="secondary" className="h-[44px]  flex-1 Body5M14">
          취소
        </Button>
      </DialogClose>
      <Button variant="solid" className="h-[44px] flex-1  Body5M14" onClick={onAdd}>
        템플릿 추가
      </Button>
    </LayoutTemplateController>
  );
};
